import { Remote } from '@/api/remote';
import { ApiConstant } from '@/constants/api_constants';
import { Constants } from '@/constants/constants';
import { Util } from '@/utils/utils';
import { useCallback, useEffect, useState } from 'react';
import { SelectItem, TosData, TosDateList } from '../../interface';
import { privacyTab } from '../../constants';

// 📌 API 함수들 (remote.api 그대로 사용)
const getPrivacyDateList = async () => {
	const response = await Remote.Api.get(ApiConstant.tosHst.list);
	if (response.code !== Constants.apiSuccess) {
		alert(response.message);
		return;
	}

	return response;
};

const getPrivacyTos = async (tosId: string, tosStdDt: string) => {
	const params = {
		tosId,
		tosStdDt
	};
	const response = await Remote.Api.get(ApiConstant.tosHst.detail, params);
	if (response.code !== Constants.apiSuccess) {
		alert(response.message);
		return;
	}

	return response;
};

export const usePrivacyPage = () => {
	const [activeTab, setActiveTab] = useState(0);
	const [selectedDate, setSelectedDate] = useState(0);
	const [dateList, setDateList] = useState<SelectItem[]>([]);
	const [tosContent, setTosContent] = useState<TosData | null>(null);

	const handleTabChange = (index: number) => {
		setTosContent(null);
		setActiveTab(index);
	};

	const handleDateChange = (index: number) => {
		setSelectedDate(index);
	};

	const fetchPrivacyDateList = useCallback(async () => {
		try {
			const tosNm = privacyTab.subTab[activeTab].name;
			const response = await getPrivacyDateList();
			const targetData = response.content.filter((item: TosDateList) => {
				const normalized = item.tosNm.replace(/\s+/g, '');
				return normalized.includes(tosNm);
			});
			const parsedDateList = targetData.map((item: TosDateList) => {
				const date = item.stDt.replace(/-/g, Constants.empty);
				const dateText = Util.convertDate(date);
				return {
					text: dateText,
					date: date,
					tosId: item.tosId
				};
			});
			setDateList(parsedDateList);

			if (parsedDateList.length > 0) {
				setSelectedDate(0);
			}
		} catch (err) {
			console.error('시행일자 리스트 불러오기 실패', err);
		}
	}, [activeTab]);

	const fetchPrivacyTos = useCallback(async () => {
		if (dateList.length === 0) return;

		try {
			const tosId = dateList[selectedDate].tosId;
			const tosStdDt = dateList[selectedDate].date;
			if (Util.isNullOrEmpty(tosId) || Util.isNullOrEmpty(tosStdDt)) return;

			const response = await getPrivacyTos(tosId, tosStdDt);
			setTosContent(response.content);
		} catch (err) {
			console.error('약관 불러오기 실패', err);
		}
	}, [activeTab, selectedDate, dateList]);

	useEffect(() => {
		if (dateList.length > 0) {
			fetchPrivacyTos();
		}
	}, [selectedDate, dateList]);

	useEffect(() => {
		fetchPrivacyDateList();
	}, [activeTab]);

	return {
		activeTab,
		dateList,
		tosContent,
		handleTabChange,
		handleDateChange
	};
};
